/* esm.sh - applesauce-common@5.2.0/dist/operations/media-attachment */
export * from "/*applesauce-common@5.2.0/esnext/dist/operations/media-attachment.mjs";
